import Timestamp from '../../Utilities/Timestamp';
import './chatUpdate.css';
import { messageShape } from './shapes';

/*
#tailwind
*/

function ChatUpdate({ message, ...other }) {
  const { message: content, timestamp: time } = message;

  return (
    <div {...other}>
      <div className="chatUpdate">
        <span className="chatUpdate__content">{content}</span>
        <span className="chatUpdate__timestamp">
          <Timestamp time={time} />
        </span>
      </div>
    </div>
  );
}

ChatUpdate.propTypes = {
  message: messageShape.isRequired,
};

export default ChatUpdate;
